import { combineReducers } from "redux";
import { accountsReducer } from "./accounts.reducer";
import { appThemeReducer } from "./appTheme.reducer";
import { budgetReducer } from "./budget.reducers";
import { cardsReducer } from "./card.reducer";
import { countTrackerReducer } from "./countTracker.reducer";
import { inviteSignatoryReducer } from "./inviteSignatory.reducer";
import { loadingReducer } from "./loadingReducer";
import { paymentsReducer } from "./payments.reducer";
import { signatoryReducer } from "./signatory.reducer";
import { signupReducer } from "./signup.reducer";
import { signInReducer } from "./signin.reducer";
import { transactionReducer } from "./transactions.reducer";
import { bulkPaymentsReducer } from "./bulkPayments.reducer";
import { analyticsReducer } from "./analytics.reducer";
import { gettingStartedReducer } from "./gettingStarted.reducer";
import { passwordResetReducer } from "./passwordReset.reducer";
import { billPaymentReducer } from "./billPayment.reducer";
import { airtimeReducer } from "./airtime.reducer";
import { paymentRequestReducer } from "./paymentRequest.reducer";
import { futureScheduledPaymentReducer } from "./futureScheduledPayment.reducer";
import { invoiceReducer } from "./invoice.reducer";
import { invoiceCustomerReducer } from "./invoiceCustomers.reducer";
import { invoiceInventoryReducer } from "./invoiceInventory.reducer";
import { invoiceSettingsReducer } from "./invoiceSettings.reducer";
import { invoicePreviewReducer } from "./invoicePreview";
import { invoiceDraftReducer } from "./invoiceDrafts.reducer";
import InvoicePaymentReduder from "./invoicePayment.reducer";
import {
    //     BizRegErrorReducer,
    //     BRInitializationReducer,
    //     BROnboardingReducer,
    //     CancelApplicationReducer,
    //     FetchBNApplicationReducer,
    //     FetchLlcApplicationReducer,
    //     InitiateBRPaymentReducer,
    //     SendBusinessEmailOtpReducer,
    //     UpdateBnRegistrationReducer,
    //     UpdateLlcRegistrationReducer,
    //     UploadBRDocumentReducer,
    //     VerifyBRPaymentReducer,
    //     VerifyBusinessEmailOtpReducer,
    businessRegistration,
} from "./businessRegistration.reducer";
import { invoiceEstimateReducer } from "./invoiceEstimate.reducer";
import payrollReducer from "../features/payroll/reducer";
import bizOnboardingReducer from "../features/onboarding/reducer";
import { openApiReducer } from "./openApiAccount.reducer";
import { openApiCustomerReducer } from "./openApiCustomers.reducer";
import { openApiTestConsoleReducer } from "./openApiConsole.reducer";
import { openApiTokenReducer } from "./openApiToken.reducer";
import { payoneerReducer } from "./payoneer.reducer";
import { DESTROY_SESSION } from "../actions/types/app.types";
import { subaccountReducer } from "./subaccounts.reducer";
import { kudaPayrollReducer } from "./payroll.reducer";
import { posReducer } from "./pos.reducer";
import { transactionHistoryReducer } from "./transactionHistory.reducer";
import { catalogueReducer } from "./catalogue.reducer";
import { SalesModeReducer } from "./salesMode.reducer";
import passkeysReducer from "../features/passkeys/reducer";

const appReducer = combineReducers({
    accountState: accountsReducer,
    airtimeState: airtimeReducer,
    analyticsState: analyticsReducer,
    appThemeState: appThemeReducer,
    billPaymentState: billPaymentReducer,
    budgetState: budgetReducer,
    bulkPaymentsState: bulkPaymentsReducer,
    cardsState: cardsReducer,
    countTrackerState: countTrackerReducer,
    gettingStartedState: gettingStartedReducer,
    inviteSignatoryState: inviteSignatoryReducer,
    loadingState: loadingReducer,
    paymentsState: paymentsReducer,
    signupState: signupReducer,
    signInState: signInReducer,
    signatoryState: signatoryReducer,
    transactionState: transactionReducer,
    passwordResetState: passwordResetReducer,
    paymentRequestState: paymentRequestReducer,
    futureScheduledPaymentState: futureScheduledPaymentReducer,
    invoiceState: invoiceReducer,
    invoiceSettingsState: invoiceSettingsReducer,
    invoiceCustomersState: invoiceCustomerReducer,
    invoiceInventoryState: invoiceInventoryReducer,
    invoicePreviewState: invoicePreviewReducer,
    invoiceDraftState: invoiceDraftReducer,
    invoicePaymentState: InvoicePaymentReduder,
    // businessRegistrationInitState: BRInitializationReducer,
    // businessRegistrationOnboardingState: BROnboardingReducer,
    // businessRegistrationDocumentUploadState: UploadBRDocumentReducer,
    // updateBnApplicationState: UpdateBnRegistrationReducer,
    // updateLlcApplicationState: UpdateLlcRegistrationReducer,
    // fetchBnApplicationState: FetchBNApplicationReducer,
    // fetchLlcApplicationState: FetchLlcApplicationReducer,
    // initiateBRPaymentState: InitiateBRPaymentReducer,
    // verifyBRPaymentState: VerifyBRPaymentReducer,
    // verifyBusinessEmailState: VerifyBusinessEmailOtpReducer,
    // sendBusinessEmailOtpState: SendBusinessEmailOtpReducer,
    // cancelApplicationState: CancelApplicationReducer,
    // bizRegErrorReducer: BizRegErrorReducer,
    businessRegistrationState: businessRegistration,
    invoiceEstimateState: invoiceEstimateReducer,
    payrollState: payrollReducer,
    openApiState: openApiReducer,
    openApiCustomerState: openApiCustomerReducer,
    openApitestConsoleState: openApiTestConsoleReducer,
    openApiTokenState: openApiTokenReducer,
    payoneerState: payoneerReducer,
    subAccountsState: subaccountReducer,
    kudaPayrollState: kudaPayrollReducer,
    posState: posReducer,
    bizOnboardingState: bizOnboardingReducer,
    transactionHistory: transactionHistoryReducer,
    catalogueState: catalogueReducer,
    salesModeState: SalesModeReducer,
    passkeysState: passkeysReducer,
});

export const rootReducer = (state, action) => {
    // Clear all data in redux store to initial.
    if (action.type === DESTROY_SESSION) state = undefined;

    return appReducer(state, action);
};
